import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppConfigService } from '../services/app-config.service';
import { Router } from '@angular/router';
import { IomService } from '../services/iom.service';
import { MsalService } from '@azure/msal-angular';
import { SessionService } from '../services/session.service';

@Injectable()
export class AppConfig {

  public envData: any = null;
  constructor(private http: HttpClient, private appConfigService: AppConfigService, private router: Router, public iomservice: IomService, private msalService: MsalService, private sessionService: SessionService) {
  }
  public load() {
    return new Promise((resolve, reject) => {     
      this.envData = this.appConfigService.getEnvironment();
      if (this.envData.AuthProvider == "PAMAuthentication") {
        this.iomservice.GetPAMTokenFromAPI().subscribe(
          data => {
            if (data != null) {
              if (data.isValidUser == true) {
                this.iomservice.IsAuthorized = true;
                sessionStorage.setItem('userName', data.user);
                sessionStorage.setItem('IOMToken', data.token);
                sessionStorage.setItem('ExpirationDate', data.expirationDate);
                this.iomservice.setPAMAuthentication(true);
                this.iomservice.setPAMAccess(true);
                resolve(true);
              }
              else {
                sessionStorage.setItem('userName', data.user);
                sessionStorage.setItem('IOMToken', data.token);
                sessionStorage.setItem('ExpirationDate', data.expirationDate);
                this.iomservice.setPAMAuthentication(true);
                this.iomservice.setPAMAccess(false);
                this.iomservice.IsAuthorized = false;
                resolve(true);
              }
            }
            else {
              let currentUrl = window.location.href;
              window.location.href = encodeURI(this.envData.PAM_URL + this.Base64Encode("{'ReturnURl':'" + currentUrl + "'}"));
              resolve(true);
            }
          },
          (err: HttpErrorResponse) => {
            let currentUrl = window.location.href;
            window.location.href = encodeURI(this.envData.PAM_URL + this.Base64Encode("{'ReturnURl':'" + currentUrl + "'}"));
            resolve(true);
          })
      }
      else if (this.envData.AuthProvider == "AzureADAuthProvider") {    
        var x = document.referrer;
        if (!x.includes('mywizardiom') && !x.includes('federation') && !x.includes('microsoftonline')) {        
          if(window.location.href.toLowerCase().includes('e2euid'))
          localStorage.setItem('ReturnURL', window.location.href);
        }
        let loggedUserName: string = this.sessionService.getUserName();
        if (this.envData.mslConfig.enableMSAL == true) {
          try {
            if (loggedUserName != null && loggedUserName != undefined) {
              this.iomservice.setPAMAccess(true); // later we removed once fds integration done
              resolve(true);              
            }
            else {
              // const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
              //if (!isIE) {
              //  this.msalService.loginRedirect();
              //} else {
              //   this.msalService.loginPopup();
              // }
              this.iomservice.setPAMAccess(true);
              resolve(true);
            }
          } catch (e) {
           // console.log('error');
            return false;
          }
        }
        else {
          this.iomservice.setPAMAccess(true);
          resolve(true);
        }
      }
      else {
        this.iomservice.setPAMAccess(true); // added to test in local purpose
        resolve(true);
      }
    });
  }
  Base64Encode(plainText: string) {
    return btoa(plainText);
  }
}
